import React, { useContext } from "react";

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import FoodExchangeCalculator from "./FoodExchangeCalculator";
import MacronutrientField from "./MacronutrientField";
import RecommendedCalories from "./RecommendedCalories";
import MealPlanFormStore from "../store/MealPlanFormStore";

interface Props {
  onSubmit(): void;
}

const useStyles = makeStyles()(() => ({
  root: {
    width: "100%",
  },
  bold: {
    fontWeight: "bold",
  },
  hidden: {
    display: "none",
  },
}));

const PlanningForm: React.FC<Props> = observer(({ onSubmit }) => {
  const { classes, cx } = useStyles();

  const store = useContext(MealPlanFormStore.Context);
  const formState = store.macronutrients.formState;

  return (
    <div className={classes.root}>
      <Box border="1px solid #edf0f5" marginBottom={2}>
        <RecommendedCalories />
      </Box>
      <Box marginBottom={5}>
        <Box marginBottom={5}>
          <Typography className={classes.bold} variant="body2">
            Macronutrients distribution
          </Typography>
          <Typography color="textSecondary">
            Set the distribution of macronutrients
          </Typography>
        </Box>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <MacronutrientField
                name="carbohydrate"
                label="Carbohydrates"
                description="Distribution of carbohydrates in the meal plan"
              />
            </Grid>
            <Grid item xs={4}>
              <MacronutrientField
                name="protein"
                label="Proteins"
                description="Distribution of proteins in the meal plan"
              />
            </Grid>
            <Grid item xs={4}>
              <MacronutrientField
                name="fat"
                label="Fats"
                description="Distribution of fats in the meal plan"
              />
            </Grid>
          </Grid>
          <Box width="100%" marginTop={1} textAlign="center">
            <Typography color="error">{formState.errors["base"]}</Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <FormControlLabel
          classes={{ label: classes.bold }}
          control={
            <Checkbox
              checked={store.foodExchange.use}
              onChange={(e) => store.foodExchange.toggle(e.target.checked)}
              color="primary"
            />
          }
          label="Use food exchange (FEL) calculator"
        />
        <div
          className={cx({
            [classes.hidden]: !store.foodExchange.use,
          })}
        >
          <FoodExchangeCalculator />
        </div>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
          marginTop={8}
        >
          <Button
            variant="outlined"
            style={{ marginRight: 5 }}
            onClick={() => store.previousStep()}
          >
            Back
          </Button>
          <Button
            disabled={formState.isInvalid}
            onClick={formState.handleSubmit(onSubmit)}
          >
            Next
          </Button>
        </Box>
      </Box>
    </div>
  );
});

export default PlanningForm;
